import {useSeoMeta} from '@unhead/react'

import {TITLE} from '@/constants/config'

export default memo<Omit<Exclude<Parameters<typeof useSeoMeta>[0], undefined>, 'titleTemplate'>>(
  function HeadTags(props) {
    useSeoMeta({
      ...props,
      titleTemplate: (title?: string) => `${title} - ${TITLE}`,
    })

    return null
  },
)
